var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{attrs:{"id":"mainApp"}},[_c('v-main',[_c('v-toast'),_c('router-view')],1)],1),_c('e-modal'),_c('e-modal-dinamic'),_c('e-loader'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enabled",attrs:{"vw":""}},[_c('div',{staticClass:"active",attrs:{"vw-access-button":""}}),_c('div',{attrs:{"vw-plugin-wrapper":""}},[_c('div',{staticClass:"vw-plugin-top-wrapper"})])])
}]

export { render, staticRenderFns }